import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Menu from './Menu/container'
import Search from './Search'
import ActionsMenu from './ActionsMenu'
import UserMenu from './UserMenu'

import { navigationMenu, navigationMenuOpened } from './SideMenu.scss'

const SideMenu = ({ setMenuOpen, isMenuOpen }) => (
  <div className={cn(navigationMenu, {[navigationMenuOpened]: isMenuOpen })}
       onMouseEnter={()=>setMenuOpen(true)}
       onMouseLeave={()=>setMenuOpen(false)}
  >
    <Menu/>
    {/*<ActionsMenu isMenuOpen={isMenuOpen}/>*/}
    {/*<Search isMenuOpen={isMenuOpen}/>*/}
    <UserMenu isMenuOpen={isMenuOpen}/>
  </div>
);

SideMenu.propTypes = {
}

export default SideMenu
